import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useSelector((state) => state.Auth);

    // Check localStorage as well for persistent login
    const storedUser = localStorage.getItem('user');

    // If user is not authenticated and no stored user data, redirect to login
    if (!isAuthenticated && !storedUser) {
        return <Navigate to="/login" replace />;
    }

    // If authenticated or has stored user data, render the protected component
    return children;
};

export default ProtectedRoute;
